import { WizardStepContextState } from "models/propTypes/wintFormPropsTypes";

export const WizardStepReducer = (state: WizardStepContextState, action: any): WizardStepContextState => {
  switch (action.type) {
    default:
      return state;
  }
};
